module.exports = __webpack_public_path__ + "static/series_3200-adc2735458cffa74bb64e43cef7995b8.png";